import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import ApplicationApiCallBackActions from '../actions/ApplicationApiCallBackActions.js';

module.exports = {
    getKillSwitch: function(killSwitchName) {
        const url = APIUrl.COMMON_KILLSWITCH_URL + killSwitchName;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                ApplicationApiCallBackActions.killSwitchRetrieveSuccess(response.data);
            })
            .catch((error) => {
                ApplicationApiCallBackActions.killSwitchRetrieveFailed(killSwitchName);
                throw Error('Get KillSwitch', error);
            });
    },

    getAsfFeeKillSwitch: function(killSwitchName) {
        const url = APIUrl.COMMON_KILLSWITCH_URL + killSwitchName;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                ApplicationApiCallBackActions.asfFormKillSwitchRetrieveSuccess(response.data);
            })
            .catch((error) => {
                ApplicationApiCallBackActions.asfFormKillSwitchRetrieveFailed(killSwitchName);
                throw Error('Get KillSwitch', error);
            });
    },

    getAsfCongratulationsPageKillSwitch: function(killSwitchName) {
        const url = APIUrl.COMMON_KILLSWITCH_URL + killSwitchName;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                ApplicationApiCallBackActions.asfCongratulationsPageKillSwitchRetrieveSuccess(response.data);
            })
            .catch((error) => {
                ApplicationApiCallBackActions.asfCongratulationsPageKillSwitchRetrieveFailed(killSwitchName);
                throw Error('Get KillSwitch', error);
            });
    },

    getCongratulationsPageDocumentKillSwitch: function(killSwitchName) {
        const url = APIUrl.COMMON_KILLSWITCH_URL + killSwitchName;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                ApplicationApiCallBackActions.CongratulationsPageDocumentKillSwitchRetrieveSuccess(response.data);
            })
            .catch((error) => {
                ApplicationApiCallBackActions.CongratulationsPageDocumentKillSwitchRetrieveFailed(killSwitchName);
                throw Error('Get KillSwitch', error);
            });
    },

    logError: function(message) {
        const data = JSON.stringify(message);
        axios.post(APIUrl.COMMON_LOG_ERROR_URL, data)
            .then(ThrowIfStatusNotOk)
            .catch((error) => {
                console.error('log error', error);
            });
    },

    extendSessionTimeout: function() {
        axios.put(APIUrl.COMMON_EXTEND_SESSION_URL, {})
            .then(() => {
                ApplicationApiCallBackActions.onContinueSession(false);
            })
            .catch((error) => {
                throw Error('Extend Session error', error);
            });
    },
    getDownsizerContributionKillSwitch: function(killSwitchName) {
        const url = APIUrl.COMMON_KILLSWITCH_URL + killSwitchName;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                ApplicationApiCallBackActions.downsizerContributionKillSwitchRetrieveSuccess(response.data);
            })
            .catch((error) => {
                ApplicationApiCallBackActions.downsizerContributionKillSwitchRetrieveFailed(killSwitchName);
                throw Error('Get KillSwitch', error);
            });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/CommonAPI.js